import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronRight, ArrowRight } from "lucide-react";

const CONTRACTED = [
  { label: "Contract", sub: "The promise", to: "/app/contracts" },
  { label: "Recurring Work / Project", sub: "The visit plan", to: "/app/job-templates" },
  { label: "Unscheduled Work", sub: "The actual visits", to: "/app/unscheduled" },
  { label: "Schedule", sub: "Booked in", to: "/app/schedule" },
];
const ADHOC = [
  { label: "Defect", sub: "Found on site", to: "/app/defects" },
  { label: "Quotation", sub: "Priced & accepted", to: "/app/quotations" },
  { label: "Job", sub: "The work", to: "/app/jobs" },
];
const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "");

function Lane({ title, steps }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[11px] uppercase tracking-wide text-slate-400 w-20 flex-shrink-0">{title}</span>
      {steps.map((s, i) => (
        <div key={s.label} className="flex items-center gap-2">
          <Link to={s.to} data-testid={`flow-step-${slug(s.label)}`}
            className="group bg-white border border-slate-200 rounded-md px-3 py-1.5 hover:border-[var(--client-accent)] transition-colors block">
            <div className="text-sm font-medium text-slate-800">{s.label}</div>
            <div className="text-[11px] text-slate-400">{s.sub}</div>
          </Link>
          {i < steps.length - 1 && <ArrowRight className="h-4 w-4 text-slate-300 flex-shrink-0" />}
        </div>
      ))}
    </div>
  );
}

export default function FlowGuide() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("flow-guide-collapsed") === "1");
  const toggle = () => setCollapsed((c) => { localStorage.setItem("flow-guide-collapsed", c ? "0" : "1"); return !c; });
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-md mb-4" data-testid="flow-guide">
      <button onClick={toggle} data-testid="flow-guide-toggle"
        className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
        {collapsed ? <ChevronRight className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
        How work flows
      </button>
      {!collapsed && (
        <div className="px-4 pb-3 space-y-2.5" data-testid="flow-guide-body">
          <Lane title="Contracted" steps={CONTRACTED} />
          <Lane title="Ad-hoc" steps={ADHOC} />
          <p className="text-[11px] text-slate-400">Recurring contracts create a Recurring Work; one-off contracts create a Project + job. Accepted quotations convert to jobs. Click any step to open it.</p>
        </div>
      )}
    </div>
  );
}
